import * as React from "react";
import { Image, useId } from "@fluentui/react-components";
import { Dropdown, Option } from "@fluentui/react-components";
import PropTypes from "prop-types";
import { proxiedUrlFor } from "../../utils/media-url-utils";

export default function ArtworkDropdown({
  className,
  positioning,
  id,
  options,
  value,
  onChange,
  placeholder,
  style,
  isMulti,
  disabled,
  appearance = "filled-lighter",
  inlinePopup = false,
  defaultValue,
  searchByLabel,
  ...rest
}) {
  const dropdownId = useId(id);
  
  const selectedLabel = options.find(option => JSON.stringify(option.label) === JSON.stringify(value))?.label;
  const selectedValue = options.find(option => JSON.stringify(option.label) === JSON.stringify(value))?.value;
  const selectedOptions = options
    .filter(option => JSON.stringify(option.value) === JSON.stringify(value))
    .map(option => option.value);

  return (
    <>
      <Dropdown
        defaultValue={defaultValue ? defaultValue : selectedLabel || "--"}
        className={className}
        style={style}
        aria-labelledby={dropdownId}
        onChange={onChange}
        value={selectedLabel}
        appearance={appearance}
        placeholder={placeholder}
        disabled={disabled}
        positioning={positioning}
        inlinePopup={inlinePopup}
        defaultSelectedOptions={[selectedValue]}
      >
        {options.map(option => (
          <Option onClick={() => onChange(option.value, option)} value={option.value} key={option.value}>
            <div style={{display: "flex", gap: "8px", alignItems: "center"}}>
              {option.img && (<Image src={proxiedUrlFor(option.img)} style={{maxWidth: "30px", maxHeight: "30px"}} alt={option.label} />)}
              <span>{option.label}</span>
            </div>
          </Option>
        ))}
      </Dropdown>
    </>
  );
}

ArtworkDropdown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  isMulti: PropTypes.bool,
  disabled: PropTypes.bool,
  appearance: PropTypes.string,
  inlinePopup: PropTypes.bool,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  style: PropTypes.object,
  positioning: PropTypes.string
};
